export const SET_USERS = 'Set users'
export const DELETE_USER = 'Delete users'
export const UPDATE_USER = 'Update users'
export const ADD_USER_DATA = 'Add users data'
export const SET_CURRENT_USER = 'Set current user'
